import React from "react";
import { Button, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { algorithms } from "../../util/constants";
import {
  getCurrentHotspot,
  getRequestedAlgorithm,
} from "../../redux/selectors";
import { setRequestedAlgorithm } from "../../redux";
import { ReactComponent as SpinIcon } from "../../assets/icons/spin.svg";
import { ReactComponent as ManualIcon } from "../../assets/icons/manual.svg";

const ManualModeSwitch = () => {
  const hotspotIndex = useSelector(getCurrentHotspot);
  const dispatch = useDispatch();
  const requestedAlgorithm = useSelector(getRequestedAlgorithm);

  const handleClick = () => {
    const newAlgorithm =
      requestedAlgorithm === algorithms.spin
        ? algorithms.manual
        : algorithms.spin;
    dispatch(setRequestedAlgorithm({ hotspotIndex, algorithm: newAlgorithm }));
  };

  const icon =
    requestedAlgorithm === algorithms.spin ? <SpinIcon /> : <ManualIcon />;

  return (
    <Tooltip
      title={`Snap to ellipse: ${
        requestedAlgorithm === algorithms.spin ? "on" : "off"
      }`}
    >
      <Button
        icon={icon}
        onClick={handleClick}
        onPointerDown={(e) => e.stopPropagation()}
        type="text"
      />
    </Tooltip>
  );
};

export default ManualModeSwitch;
